export function openDrawer(state) {
  state.showDrawer = true;
}

export function closeDrawer(state) {
  state.showDrawer = false;
}

export function setActiveTab(state, { name }) {
  state.activeTab = name;
}
